import { newGuid } from './utils'

const start = new Date()
const sessionGuid = newGuid()

export const startTime = () => start.toISOString()
export const guid = () => sessionGuid
export const elapsedTime = () => new Date().getTime() - start.getTime()
